<style lang="scss">
    .row-song-container:hover {
        .item-overlay {
            opacity: 1;
            display: block;
        }
    }
    .row-song-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;
        border-radius: 5px;

        &.active {
            background: #ffedf3;
        }

        .left-col {
            flex: 2;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            display: flex;
            align-items: center;
        }
        .right-col {
            display: flex;
            align-items: center;
        }

        .boxed {
            background-image: linear-gradient(135deg, #8f40b0 0%, #642d7b 100%);
            opacity: 0.6;
        }

        .text-center {
            margin-top: 20px;
            padding-left: 0px !important;
            padding-right: 0px !important;
        }

        .shadow {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            border: 0;
            border-radius: 5px;
            z-index: 1;
        }

        .item-overlay {
            z-index : 3;
            position: inherit !important;
            .row-song-container:focus,
            .row-song-container:hover & {
                opacity: 1;
                display: block;
            }
        }

        .item-media {
            display: inline-block;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
            border-radius: 5px;
            height: 50px;
            width : 50px;
            min-width: 50px;
            overflow: inherit;
        }

        .item-title {
            color: #363c43;
            font-family: Poppins;
            font-weight: 600;
            font-size: 14px;
            background: none;
            text-overflow : ellipsis;
            overflow: hidden;
            margin-left: 10px;
            a {
                white-space: nowrap;
            }
        }
        .row-btn-playpause {
            background: #fff;
            color: #8f40b0;
            position: absolute;
            top: 2px;
            left: 2px;
            padding: 0 0px;
        }

        .quarter {
            width: 15px;
            height: 14px;
            background-color: #ffffff;
            opacity: 0.52;
        }

        .top-right {
            border-top-right-radius: 24px;
            border-bottom-right-radius: 3px;
            border-top-left-radius: 3px;
            position: absolute;
            right: 0;
            top: 0;
        }

        .bottom-left {
            border-bottom-left-radius: 24px;
            position: absolute;
            border-top-left-radius: 3px;
            border-bottom-right-radius: 3px;
            bottom: 0;
            left: 0;
        }

        #circle-container {
            width: 30px;
            height: 30px;
            position:relative;
            z-index:1;
        }

        .item-media-colomn {
            display: -webkit-box;
            overflow: hidden;
        }

        .center {
            position: absolute;
            padding: 0 !important;
            top: 50%;
            left: 50%;
            margin-top: -15px;
            margin-left: -15px;
        }

        .item-text {
            font-family: Poppins;
            font-size: 11px;
            font-weight: 400;
        }

        .share-button {
            margin-right: 20px;
        }

        .price {
            color: rgb(255, 255, 255);
            height: 34px;
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
            border-radius: 5px;
            background-color: #8f40b0;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 400;
            padding: 10px;
            &.in-cart {
                padding: 9px;
                border: 1px solid;
            }
        }

        .download-button {
            color: #00d38a;
            float: right;
            margin-right: 10px;
        }

        .border {
            position: absolute;
            bottom: -1px;
            width: 90%;
            border-bottom: 1px solid #e6e6e6;
            margin: auto;
            left: 5%;
        }

    }

</style>

<template>
    <div class="row-song row-song-container" @mouseover="hover(true)" @mouseleave="hover(false)" :style="$rowItemStyle" :class="{'active': active}" @click="play()">
        <div class="left-col">
            <span class="item-media" >
                <div class="shadow" :class="{'boxed': hovered }"></div>
                <div class="item-media-content" :style="{'background-image': 'url(' +  song.image(imageSize) + ')'}"></div>
                <div class="item-overlay center">
                    <div id="circle-container">
                        <div class="quarter top-right" :style="$itemPlayButtonStyle"></div>
                        <div class="quarter bottom-left" :style="$itemPlayButtonStyle"></div>
                        <button v-if="isPlaying == true" class="row-btn-playpause" :style="$itemPlayButtonStyle">
                            <font-awesome-icon icon="pause"></font-awesome-icon>
                        </button>

                        <button v-else class="row-btn-playpause" :style="$itemPlayButtonStyle">
                            <font-awesome-icon icon="play"></font-awesome-icon>
                        </button>
                    </div>
                </div>
            </span>
            <span class="item-title" :style="$rowItemHighlightTextStyle">
                <router-link @click.native.stop="" :to="{name: 'song', params: {song: song.id}}">{{song.name}}</router-link>
            </span>
        </div>
        <div class="right-col">
            <share-button :parent="this.parent" :item="song" :style="shareButtonStyle"></share-button>
            <buy-button v-if="song.price > 0" :item="song"></buy-button>
            <download-button v-else-if="song.freeDownload" :item="song"></download-button>
        </div>

        <div class="border" :style="$dividerStyle"></div>
    </div>

</template>

<script>
    import Configure from '../mixins/configure'
    import ShareButton from './sharebutton.vue'
    import DownloadButton from './downloadbutton.vue'
    import BuyButton from './shared/buy-button.vue'

    export default {
        props: {
            'parent':{
                type: Object,
                default: null
            },
            'song': {
                type: Object,
                required: true
            },
            'showPrice': {
                type: Boolean,
                default: false
            },
            'imageSize': {
                type: [Number, String],
                default: 100
            }
        },
        created () {
            this.$data.$display = 'list'
        },
        components: {
            ShareButton, DownloadButton, BuyButton
        },
        computed: {
            active () {
                if (this.currentlyPlayingItem == this.song) {
                    this.$data.$active.musicContainer = true
                    return true
                }

                this.$data.$active.musicContainer = false
                return false
            },
            playerActive () {
                return this.$store.state.player.playing
            },
            playlistManager () {
                return this.$store.state.playlistManager
            },
            currentlyPlayingItem () {
                return this.playlistManager.getCurrentlyPlaying()
            },
            isPlaying () {
                return (this.playlistManager.isPlaying(this.song) && this.playerActive)
            },
            isPaused () {
                return (this.playlistManager.isPlaying(this.song) && !this.playerActive)
            },
            hovered () {
                return this.$data.$hover.musicContainer;
            },
            shareButtonStyle() {
                if (this.$data.$active.musicContainer) {
                    return this.$rowItemMainTextStyle
                } else {
                    return this.$mainSecondaryTextStyle
                }
            }
        },
        mixins: [Configure],
        methods: {
            hover (isHovering) {
                this.$data.$hover.musicContainer = isHovering
            },
            play () {
                if (this.isPlaying) {
                    this.song.pause()
                } else {
                    this.song.play()
                }
            }
        }
    }
</script>
